export default "__VITE_ASSET__Brezl3UV__"